
import Vue from "vue"

export default Vue.extend({
  name: "AlertWarning.vue",
  props: {
    message: String
  }
})
